var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    stroke: "white",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9984 6.46602C14.9484 6.45769 14.8901 6.45769 14.8401 6.46602C13.6901 6.42435 12.7734 5.48268 12.7734 4.31602C12.7734 3.12435 13.7318 2.16602 14.9234 2.16602C16.1151 2.16602 17.0734 3.13268 17.0734 4.31602C17.0651 5.48268 16.1484 6.42435 14.9984 6.46602Z",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1402 12.5328C15.2819 12.7245 16.5402 12.5245 17.4236 11.9328C18.5986 11.1495 18.5986 9.86615 17.4236 9.08282C16.5319 8.49115 15.2569 8.29115 14.1152 8.49115",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97344 6.46602C5.02344 6.45769 5.08177 6.45769 5.13177 6.46602C6.28177 6.42435 7.19844 5.48268 7.19844 4.31602C7.19844 3.12435 6.24011 2.16602 5.04844 2.16602C3.85677 2.16602 2.89844 3.13268 2.89844 4.31602C2.90677 5.48268 3.82344 6.42435 4.97344 6.46602Z",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8306 12.5328C4.68893 12.7245 3.4306 12.5245 2.54727 11.9328C1.37227 11.1495 1.37227 9.86615 2.54727 9.08282C3.43893 8.49115 4.71393 8.29115 5.8556 8.49115",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.6906C9.95039 12.6823 9.89206 12.6823 9.84206 12.6906C8.69206 12.649 7.77539 11.7073 7.77539 10.5406C7.77539 9.34896 8.73372 8.39062 9.92539 8.39062C11.1171 8.39062 12.0754 9.35729 12.0754 10.5406C12.0671 11.7073 11.1504 12.6573 10.0004 12.6906Z",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57461 15.3148C6.39961 16.0982 6.39961 17.3815 7.57461 18.1648C8.90794 19.0565 11.0913 19.0565 12.4246 18.1648C13.5996 17.3815 13.5996 16.0982 12.4246 15.3148C11.0996 14.4315 8.90794 14.4315 7.57461 15.3148Z",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.0bc656966b9772e5f99568034216162d.svg";
export { ForwardRef as ReactComponent };